

export class DepartCreater {
  constructor(payload) {
    this.name = ''
    this.pid = payload.pid
    this.departmentHeadUserId = ''
    this.memo = ''
    this.deptType = 20
  }
}

export class PwdCreater {
  constructor() {
    this.userId = localStorage.getItem('jti')
    this.oldPassword = ''
    this.newPassword = ''
    this.confirmPwd = ''
  }
}

export class SecondPwdCreater {
  constructor() {
    this.userId = localStorage.getItem('jti')
    this.oldSecondaryPassword = ''
    this.newSecondaryPassword = ''
    this.confirmPwd = '' 
  }
}

export class InviteCreater {
  constructor() {
    this.nickName = ''
    this.phone = ''
    this.deptId = ''
  }
}

export class ContactCreater {
  constructor() {
    this.name = ''
    this.job = ''
    this.mobile = ''
    this.mail = ''
  }
}

export class AccountCreater {
  constructor(params = {}) {
    this.customerId = params.customerId ? params.customerId : ''
    this.createMonth = ''
    this.subjectId = ''
    this.corporateIncomeTaxType = params.vatCollectionType ? params.vatCollectionType : ''
    this.incomeTaxCollectionType = params.incomeTaxCollectionType ? params.incomeTaxCollectionType : ''
    this.businessNature = params.businessNature ? params.businessNature : ''
    // this.taxableIncomeRate = ''
    this.asKuaiji = ''
    this.asJizhang = ''
    this.asShenhe = ''
    this.asChuna = ''
    this.asZhidan = ''
    this.wsFuze = ''
    this.wsKuaiji = ''
    this.wsCangku = ''
    this.wsJingban = ''
    this.wsZhidan = ''
    this.businessType = params.businessType ? params.businessType : ''
    this.taxIdentificationNum = params.taxIdentificationNum ? params.taxIdentificationNum : ''
    this.customerFullName = params.customerFullName ? params.customerFullName : ''
    this.vatType = params.vatType ? params.vatType : ''
    this.noTicketIncome = params.vatType === 20 ? 1 : ''
    this.isWarehouseAccount = params.vatType === 20 ? 0 : 1
    this.businessNatureType = params.businessNatureType ? params.businessNatureType : ''
    this.companyType = params.companyType ? params.companyType : ''
  }
}

export class ManagementCreate {
  constructor(params) {
    this.type = params.type
    this.name = ""
    this.alias = ""
    this.length = params.length || params.length === 0 ? params.length : 1
  }
}

export class CreateGroup {
  constructor(payload = {}){
    this.name = payload.name ? payload.name : ''
    this.groupId = payload.groupId ? payload.groupId : ''
    this.pCode = payload.pCode ? payload.pCode : 0
    this.children = payload.children ? payload.children : []
  }
}

export class CreateUpdateGroup {
  constructor(payload = {}){
    this.name = payload.name
    this.groupId = payload.groupId
    this.code = payload.code
    this.sortNum = payload.sortNum
  }
}

export class CreateTeamGroup {
  constructor(payload = {}){
    this.id = payload.id ? payload.id : ''
    this.name = payload.name ? payload.name : ''
    this.pid = payload.pid ? payload.pid : ''
    this.level = 20
    this.memo = payload.memo ? payload.memo : ''
    this.departmentHeadUserId = payload.departmentHeadUserId ? payload.departmentHeadUserId : ''
    this.auditUserId = payload.auditUserId ? payload.auditUserId : ''
    this.memberIds = payload.memberIds ? payload.memberIds : []
  }
}

export class InitCreateDepartment{
  constructor(payload = {}) {
    this.id = payload.id ? payload.id : undefined
    this.pid = payload.pid ? payload.pid : ''
    this.deptType = 10
    this.level = payload.level === 0 ? 10 : payload.level
    this.departmentHeadUserId = payload.departmentHeadUserId ? payload.departmentHeadUserId : ''
    this.name = payload.name ? payload.name : ''
    this.memo = payload.memo ? payload.memo : ''
    this.memberIds = payload.memberIds ? payload.memberIds : []
    this.members = payload.members ? payload.members : []
  }
}

export class InitCreateTeam{
  constructor(payload = {}) {
    this.id = payload.id ? payload.id : undefined
    this.pid = payload.pid ? payload.pid : ''
    this.deptType = 20
    this.level = payload.level === 0 ? 10 : payload.level
    this.departmentHeadUserId = payload.departmentHeadUserId ? payload.departmentHeadUserId : ''
    this.name = payload.name ? payload.name : ''
    this.memo = payload.memo ? payload.memo : ''
    this.memberIds = payload.memberIds ? payload.memberIds : ''
    this.members = payload.members ? payload.members : []
    this.departmentHeader = payload.departmentHeader
  }
}

export class InitCreatePosition{
  constructor(payload = {}) {
    this.id = payload.id ? payload.id : undefined
    this.positionId = payload.positionId ? payload.positionId : undefined
    this.positionName = payload.positionName ? payload.positionName : ''
    this.remark = payload.remark ? payload.remark : ''
    this.userIdList = payload.userIdList ? payload.userIdList : []
    this.dataPermissionConfig = payload.dataPermissionConfig ? payload.dataPermissionConfig : ''
    this.permissionList = payload.permissionList ? payload.permissionList : []
    this.permissionIdList = payload.permissionIdList ? payload.permissionIdList : []
  }
}

export class InitCreateJob{
  constructor(payload = {}) {
    this.id = payload.id ? payload.id : undefined
    this.postId = payload.postId ? payload.postId : undefined
    this.postName = payload.postName ? payload.postName : ''
    this.remark = payload.remark ? payload.remark : ''
    this.permissionIdList = payload.permissionIdList ? payload.permissionIdList : []
    this.dataPermissionConfig = payload.dataPermissionConfig ? payload.dataPermissionConfig : ''
    this.userIdList = payload.userIdList ? payload.userIdList : []
    this.permissionList = payload.permissionList ? payload.permissionList : []
    this.scheduleUsers = payload.scheduleUsers ? payload.scheduleUsers : []
  }
}

export class InitCreateRole{
  constructor(payload = {}) {
    this.id = payload.id ? payload.id : undefined
    this.groupRoleId = payload.groupRoleId ? payload.groupRoleId : undefined
    this.groupRoleName = payload.groupRoleName ? payload.groupRoleName : ''
    this.remark = payload.remark ? payload.remark : ''
    this.permissionIdList = payload.permissionIdList ? payload.permissionIdList : []
    this.dataPermissionConfigList = payload.dataPermissionConfigList && payload.dataPermissionConfigList.length > 0 ? payload.dataPermissionConfigList : []
    this.userIdList = payload.userIdList ? payload.userIdList : []
    this.permissionList = payload.permissionList ? payload.permissionList : []
  }
}

export class InitMemberInfo{
  constructor(payload = {}){
    const defaults = {
      proxyTaxAccount: null,
      userId: undefined,
      nickName: '',
      phone: '',
      employeeNumber: '',
      emergencyContact: '',
      emergencyPhone: '',
      maritalStatus: 0,
      identityCard: '',
      homeAddress: '',
      boardDate: '',
      jobStatus: 10,
      sex: null,
      deptId: '',
      familyList: [],
      postIdList: [],
      positionIdList: [],
      roleIdList: [],
      permissionList: [],
      remark: '',
      wechatQrCode: '',
      avatar: '',
      commissionerQrCode: '',
      managementDeptIdList: [],
      isCommissioner: 0,
      bankName: '',
      salaryAccount: '',
      groupId: '',
      resignDate: '',
      referrerUserPhones: []
    }

    Object.assign(this,defaults,payload)

    if(payload.serviceAreaList) {
      const list = []
      payload.serviceAreaList.forEach(item => list.push([item.province,item.city,item.district]))
      this.serviceAreaList = list
    }else{
      this.serviceAreaList = []
    }
    console.log(this)
  }
}

export class InitBindPosition{
  constructor(payload = {}){
    this.userIdList = []
    this.id = ''
    this.configOrRelieve = 1
  }
}

export class AccCreator {
  constructor(param = {}) {
    this.accountId = param.accountId ? param.accountId : ''
    this.accountType = param.accountType ? param.accountType : 10
    this.name = param.name ? param.name : ''
    this.bankName = param.bankName ? param.bankName : ''
    this.bankAccount =  param.bankAccount ? param.bankAccount : ''
    this.used = param.used !== undefined ? param.used : 1
    this.status = param.status !== undefined ? param.status : 1
    this.publicAccountName = param.publicAccountName ? param.publicAccountName : ''
    this.appId = param.appId ? param.appId : ''
    this.appSecret = param.appSecret ? param.appSecret : ''
    this.businessNumber = param.businessNumber ? param.businessNumber : ''
    this.paymentKey = param.paymentKey ? param.paymentKey : ''
    this.authorizationVerificationFile = param.authorizationVerificationFile ? param.authorizationVerificationFile : {filePath: '',fileName: ''}
    this.refundCertificateFile = param.refundCertificateFile ? param.refundCertificateFile : {filePath: '',fileName: ''}
    this.payeeId = param.payeeId ? param.payeeId : ''
  }
} 

export class PrintCreator {
  constructor(param = {}) {
    this.printType = param.printType
    this.currencyCode = param.currencyCode ? param.currencyCode : null
    this.printBill = param.printBill ? param.printBill : null
    this.allFirstCode = param.allFirstCode ? param.allFirstCode : null
    this.isOpenning = param.isOpenning ? param.isOpenning : null
    this.isCurrent =  param.isCurrent ? param.isCurrent : null
    this.isAccumulated =  param.isAccumulated ? param.isAccumulated : null
    this.isEnding = param.isEnding ? param.isEnding : null
    this.bankAccountId = param.bankAccountId ? param.bankAccountId : null
    this.returnCatalog = param.returnCatalog ? param.returnCatalog : false
    this.outputPaperType = param.outputPaperType
  }
}

export class AuditingParams {
  constructor(data,) {
    this.auditId = data.auditId
    this.fixedAssets = data.fixedAssets
    if (!data.attentions || data.attentions.length === 0) {
      this.attention = data.attention
    } else {
      const item = data.attentions.find(item => item.userId === localStorage.getItem('jti'))
      this.attention = item ? item.attention : ''
    }
    
    this.deptReplenish = data.deptReplenish
    this.managerReplenish = data.managerReplenish
    this.finAuditDataList = data.finAuditDataList
  }
}


export class ExpenseCreator {
  constructor(param = {}) {
    this.expensesId = param.expensesId
    this.expensesPeopleId = param.expensesPeopleId ? param.expensesPeopleId : null
    this.costDeptId = param.costDeptId ? param.costDeptId : null
    this.companyId = param.companyId ? param.companyId : null
    this.collectionAccount =  param.collectionAccount ? param.collectionAccount : null
    this.depositBank =  param.depositBank ? param.depositBank : null
    this.annexQuantity = param.annexQuantity ? param.annexQuantity : null
    this.accountId = param.accountId ? param.accountId : null
    this.annexUrls = param.annexUrls ? param.annexUrls : []
    this.remark = param.remark ? param.remark : null
    this.saveType = param.saveType ? param.saveType : null
    this.expensesDetails = param.expensesDetails ? param.expensesDetails : [new ExpenseRowDetail()]
    this.paymentAmount = ''
    this.createDate = param.createDate ? param.createDate : new Date()
    this.verifyTime = param.verifyTime ? param.verifyTime : ''
    this.receivingAccountId = param.receivingAccountId ? param.receivingAccountId : ''
    this.receivingBankAccount = param.receivingBankAccount ? param.receivingBankAccount : ''
    this.receivingDeptId = param.receivingDeptId ? param.receivingDeptId : ''
    this.receivingServiceUnit = param.receivingServiceUnit ? param.receivingServiceUnit : ''
  }
}


export class ExpenseRowDetail {
  constructor(param = {}) {
    this.id = null
    this.expensesDetailId = param.expensesDetailId ? param.expensesDetailId : null
    this.expensesId = param.expensesId ? param.expensesId : null
    this.configId = param.configId ? param.configId : null
    this.expensesAmount = param.expensesAmount ? param.expensesAmount : null
    this.summary =  param.summary ? param.summary : null
    this.supplierName =  param.supplierName ? param.supplierName : null
    this.supplierId = param.supplierId ? param.supplierId : null
    this.invoiceNumber = param.invoiceNumber ? param.invoiceNumber : '0'
    this.expensesReceiptDate = param.expensesReceiptDate ? param.expensesReceiptDate : null
    this.detailRemark = param.detailRemark ? param.detailRemark : null
  }
}

export class SupplierCreater {
  constructor(payload = {}) {
    this.bankAccount = (payload.bankAccount ? payload.bankAccount : '')
    this.bankName = (payload.bankName ? payload.bankName : '')
    this.contacts = (payload.contacts ? payload.contacts : '')
    this.customerId = (payload.customerId ? payload.customerId : '')
    this.email = (payload.email ? payload.email : '')
    this.nowAddr = (payload.nowAddr ? payload.nowAddr : '')
    this.city = (payload.city ? payload.city : '')
    this.province = (payload.province ? payload.province : '')
    this.district = (payload.district ? payload.district : '')
    this.remark = (payload.remark ? payload.remark : '')
    this.supplierName = (payload.supplierName ? payload.supplierName : '')
    this.supplierState = (payload.supplierState ? payload.supplierState : 1)
    this.taxId = (payload.taxId ? payload.taxId : '')
    this.tele = (payload.tele ? payload.tele : '')
    this.classification = (payload.classification ? payload.classification : '')
    this.endingExchange = payload.endingExchange ? 1 : 0
    this.currencies = payload.currencies ? payload.currencies : ''
    payload.supplierId ? this.supplierId = payload.supplierId : ''
  }
}

export class ReimConfigCreator {
  constructor(param = {}) {
    this.configType = 10
    this.typeName = param.typeName ? param.typeName : ''
    this.beanId = param.beanId ? param.beanId : ''
    this.summary = param.summary ? param.summary : ''
    this.beanFullName = param.beanFullName ? param.beanFullName : ''
    this.beanCode = param.beanCode ? param.beanCode : ''
  }
}



export class ReceiptCreator {
  constructor(param = {}) {
    this.revenueId = param.revenueId
    this.createDate = param.createDate ? param.createDate : new Date()
    this.revenuePeopleId = param.revenuePeopleId ? param.revenuePeopleId : null
    this.costDeptId = param.costDeptId ? param.costDeptId : null
    this.companyId = param.companyId ? param.companyId : null
    this.classifyId = param.classifyId ? param.classifyId : null
    this.verifyTime = param.verifyTime ? param.verifyTime : ''
    this.customerId = param.customerId ? param.customerId : ''
    // this.receiptNumber = param.receiptNumber ? param.receiptNumber : null
    this.collectionAccount =  param.collectionAccount ? param.collectionAccount : null
    this.includeInvoice = param.includeInvoice ? param.includeInvoice : 0
    this.depositBank =  param.depositBank ? param.depositBank : null
    this.annexQuantity = param.annexQuantity ? param.annexQuantity : null
    this.accountId = param.accountId ? param.accountId : null
    this.annexUrls = param.annexUrls ? param.annexUrls : []
    this.remark = param.remark ? param.remark : null
    this.saveType = param.saveType ? param.saveType : null

    this.revenueDetails = param.revenueDetails ? param.revenueDetails : [new RevenueRowDetail()]
    this.receivedAmount = ''
    this.receiptNumber = null
    this.receiptAssignId = null
  }
}

export class RevenueRowDetail {
  constructor(param = {}) {
    this.revenueId = param.revenueId ? param.revenueId : null
    this.configId = param.configId ? param.configId : null
    this.revenueAmount = param.revenueAmount ? param.revenueAmount : null
    this.revenueAmountStatement = param.revenueAmountStatement ? param.revenueAmountStatement : null
    this.summary =  param.summary ? param.summary : null
    this.detailRemark = param.detailRemark ? param.detailRemark : null
    this.orderId = param.orderId ? param.orderId : null
    this.orderNumber = param.orderNumber ? param.orderNumber : null
    this.paymentPlanIds = param.paymentPlanIds ? param.paymentPlanIds : ''
    this.validity = param.validity ? param.validity : null
  }
}


export class CollectionTypeCreator {
  constructor(param = {}) {
    this.classifyId = localStorage.getItem('incomeClassifyId') ? localStorage.getItem('incomeClassifyId') : null
    this.configType = 20
    this.isStat = param.isStat ? param.isStat : 0
    this.typeName = param.typeName ? param.typeName : ''
    this.beanId = param.beanId ? param.beanId : ''
    this.summary = param.summary ? param.summary : ''
    this.beanFullName = param.beanFullName ? param.beanFullName : ''
    this.beanCode = param.beanCode ? param.beanCode : ''
    this.categoryIds = []
  }
}


export class WageConfigCreator {
  constructor(param = {}) {
    this.nickname = null
    this.deptIds = null
    this.employeeNumber = null
    this.phone = null
    this.postIds = null
    this.wageStatus = 10
    this.basicWage = null
    this.overtimeWage = null
    this.attendanceBonus = null
    this.phoneSubsidy = null
    this.outsideSubsidy = null
    this.postSubsidy = null
    this.highTemperatureSubsidy = null
    this.personSocialSecurity = null
    this.companySocialSecurity = null
    this.parkingFee = null
    this.financeKpiOther = null
    this.makeInvoice = null
    this.buyTicketAndAuthenticationOther = null
    this.extraCharge = null
    this.headOfficeIndividualParameter = null
    this.headOfficeNotIndividualParameter = null
    this.deptOneRatio = null
    this.headOfficeOtherDeptRewards = null
    this.lcParameter = null
    this.lcIndividualParameter = null
    this.lcNotIndividualParameter = null
    this.accountantDeptNormalRatio = null
    this.accountantDeptSmallScaleRatio = null
    this.lcOtherDeptRewards = null
    this.defaultDeptId = null
  }
}


// WEBPACK FOOTER //
// ./src/util/formCreater.js